import de from './de'
import en from './en'

export let locales = [
  {
    value: 'en',
    name: 'English',
    native: 'English',
  },
  {
    value: 'de',
    name: 'German',
    native: 'Deutsch',
  }
]

export default {
  de, en
}
